import React, { useEffect, useState } from "react";
import "./History.css";
import AddBooking from "./EditBooking"; // Assuming you have the AddBooking component
import EditBooking from "./EditBooking"; // Import the EditBooking component
import Popup from "./Popup"; // Importing the Popup component
import DeleteConfirmationModal from "./DeleteConfirmationModal"; // Import the modal
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Checkbox,
  FormControlLabel,
  Button,
  Box,
  Paper,
  IconButton,
  Tooltip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Typography,
} from "@mui/material";
import { enqueueSnackbar } from "notistack";
import servicesList from "../Data/ServicesData";
import Loader from "./Loader";
import { apiUrl } from "./LoginSignup";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import DownloadIcon from "@mui/icons-material/Download";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { canAccessFeature, isHigherAuthority } from "../utils/featureAccess";
import { jsonToCSV, downloadCSV } from "./exelData";
import { getBookingRefundableLabel } from "../utils/bookingRevenue";
import { useColorMode } from "../context/AppThemeProvider"; // Import for theming
import { ALL_PAYMENT_METHODS } from "../utils/paymentMethods";

const TERM_KEYS = Array.from({ length: 10 }, (_, index) => `term_${index + 1}`);

const History = () => {
  const { mode } = useColorMode(); // Extract theme mode
  const [bookings, setBookings] = useState([]); // Initialize bookings as an empty array
  const [loading, setLoading] = useState(true);
  const [openDialogInfo, setOpenDialogInfo] = useState({ bookingIndex: null, updateIndex: null });
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 100;

  // Handle view details click
  const handleViewDetailsClick = (bookingIndex, updateIndex) => {
    setOpenDialogInfo({ bookingIndex, updateIndex });
  };


  // Close modal
  const handleCloseModal = () => {
    setOpenDialogInfo({ bookingIndex: null, updateIndex: null });

  };

  //New Changes by Jitendra
  const [selectedFields, setSelectedFields] = useState({
    companyName: true,
    bdmName: true,
    contactNo: true,
    email: true,
    bookingDate: true,
    paymentDate: true,
    totalPayment: true,
    receivedPayment: true,
    afterDisbursement: true,
    remark: true,
    services: true,
    gst: true, // Added GST checkbox
    state: true, // Added State checkbox
    pan: true, // Added PAN checkbox
    termType: true,
  });

  const [openPopupD, setOpenPopupD] = useState(false);

  //changes end
  const [searchInput, setSearchInput] = useState(""); // Single input field for both company name and booking ID
  const [bdmSearch, setBdmSearch] = useState("");
  const [startDate, setStartDate] = useState(""); // Add startDate state
  const [endDate, setEndDate] = useState(""); // Add endDate state
  const [status, setStatus] = useState(""); // State for the status filter
  const [userRole, setUserRole] = useState("");
  const [userId, setUserId] = useState(""); // Store the logged-in user's ID
  const [isPopupOpen, setIsPopupOpen] = useState(false); // State to control popup visibility
  const [editBooking, setEditBooking] = useState(null); // State to hold the booking to be edited
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false); // State for delete confirmation modal
  const [bookingToDelete, setBookingToDelete] = useState(null); // Track which booking to delete
  const [services, setService] = useState(""); //state for sevrvice filter
  const [paymentmode, setPaymentmode] = useState("");
  const [exelData, setexelData] = useState("");
  const userSession = JSON.parse(localStorage.getItem("userSession"));

  const formatHistoryValue = (value) => {
    if (value === undefined || value === null || value === "") return "N/A";
    if (Array.isArray(value) || typeof value === "object") {
      try {
        return JSON.stringify(value);
      } catch {
        return String(value);
      }
    }
    return String(value);
  };

  const getVisibleHistoryChanges = (changes = {}) =>
    Object.entries(changes || {}).filter(([, value]) => (
      formatHistoryValue(value?.old) !== formatHistoryValue(value?.new)
    ));

  const [activeFilters, setActiveFilters] = useState({});
  const [downloadAll, setDownloadAll] = useState(false); // ✅ checkbox state
  const [dateType, setDateType] = useState("booking");
  const [selectedMonth, setSelectedMonth] = useState("");
  const isAdminView = ["dev", "admin", "senior admin", "srdev", "super admin", "director"].includes(
    (userSession?.user_role || "").toLowerCase()
  );
  const canDownloadBookings = ["dev", "srdev", "sr dev", "director"].includes(
    (userSession?.user_role || "").toLowerCase()
  );
  const canDeleteContinuationTerms = ["dev", "developer", "srdev", "sr dev", "sr developer", "director"].includes(
    (userRole || userSession?.user_role || "").toLowerCase()
  );

  // NEW State for Shared Bookings Toggle
  const [shareFilter, setShareFilter] = useState("All"); // "All" | "SharedByMe" | "SharedWithMe"
  const [expandedTerms, setExpandedTerms] = useState({});

  // Document viewing state
  const [documentsDialogOpen, setDocumentsDialogOpen] = useState(false);
  const [selectedBookingDocs, setSelectedBookingDocs] = useState(null);
  const [bookingDocuments, setBookingDocuments] = useState([]);
  const [docsLoading, setDocsLoading] = useState(false);
  const [usersMap, setUsersMap] = useState({});
  const [selectedBookingDetails, setSelectedBookingDetails] = useState(null);

  const toggleTermCard = (bookingId, termKey) => {
    const stateKey = `${bookingId}-${termKey}`;
    setExpandedTerms((prev) => ({
      ...prev,
      [stateKey]: !prev[stateKey],
    }));
  };

  const isTermExpanded = (bookingId, termKey) => Boolean(expandedTerms[`${bookingId}-${termKey}`]);

  const getTermAmount = (booking, termKey) => Number(booking?.[termKey] || 0);

  const getTermShareInfo = (booking, termKey) => {
    const termShare = booking?.term_shares?.[termKey] || {};
    const creator = termShare?.creator || {
      user_id: booking?.user_id,
      user_name: booking?.bdm,
    };
    const sharedWith = Array.isArray(termShare?.shared_with) ? termShare.shared_with : [];

    return {
      creatorName: upperText(creator?.user_name || usersMap[creator?.user_id] || booking?.bdm || "N/A"),
      paymentDate: termShare?.payment_date || booking?.payment_date || booking?.date,
      paymentMode: termShare?.payment_mode || booking?.bank || "N/A",
      sharedWith,
    };
  };

  const getReceivedAmount = (booking) =>
    TERM_KEYS.reduce((sum, termKey) => sum + Number(booking?.[termKey] || 0), 0);

  const renderSharedWithList = (sharedList = [], emptyLabel = "Not Shared") => (
    Array.isArray(sharedList) && sharedList.length > 0 ? (
      <ul className="booking-meta-list">
        {sharedList.map((sw, idx) => (
          <li key={`${sw.user_id || "shared"}-${idx}`}>
            <strong>{upperText(sw.user_name || usersMap[sw.user_id] || "Coworker")}</strong> - {sw.percentage}%
          </li>
        ))}
      </ul>
    ) : emptyLabel
  );

  const renderDetailItem = (label, value, options = {}) => (
    <div className={`booking-detail-item${options.highlight ? " booking-detail-item-highlight" : ""}`}>
      <span className="booking-detail-label">{label}</span>
      <div className="booking-detail-value">{value}</div>
    </div>
  );

  const openBookingDetails = (booking) => {
    setSelectedBookingDetails(booking);
  };

  const closeBookingDetails = () => {
    setSelectedBookingDetails(null);
  };

  const cardTones = [
    { bg: "#f5fbff", border: "rgba(96, 165, 250, 0.30)", term2: "#f0f7ff", term3: "#edf5ff" },
    { bg: "#fff7fb", border: "rgba(232, 121, 249, 0.26)", term2: "#fff2fb", term3: "#fff0fb" },
    { bg: "#f7fcf8", border: "rgba(52, 211, 153, 0.28)", term2: "#f1faf4", term3: "#eef9f3" },
    { bg: "#fffaf3", border: "rgba(251, 146, 60, 0.26)", term2: "#fff7ef", term3: "#fff5ec" },
  ];

  const getBookingTone = (index, variant = "primary") => {
    const tone = cardTones[Math.floor(index / 2) % cardTones.length];
    if (mode === "dark") {
      if (variant === "term_2") {
        return { backgroundColor: "#0f172a", borderColor: "rgba(96, 165, 250, 0.45)", color: "#e5e7eb" };
      }
      if (variant === "term_3") {
        return { backgroundColor: "#0f172a", borderColor: "rgba(52, 211, 153, 0.42)", color: "#e5e7eb" };
      }
      return { backgroundColor: "#0f172a", borderColor: "rgba(96, 165, 250, 0.32)", color: "#e5e7eb" };
    }

    return {
      backgroundColor: variant === "term_2" ? tone.term2 : variant === "term_3" ? tone.term3 : tone.bg,
      borderColor: tone.border,
      color: "#1f2937",
    };
  };

  useEffect(() => {
    // Retroactively map user IDs to names for older bookings
    if (userSession && userSession.token) {
      fetch(`${apiUrl}/user/options`, {
        headers: { 'Authorization': userSession.token }
      })
      .then(res => res.json())
      .then(data => {
        if (data && data.users) {
          const map = {};
          data.users.forEach(u => map[u._id] = u.name);
          setUsersMap(map);
        }
      })
      .catch(err => console.error("Error fetching users options:", err));
    }
  }, []);

  useEffect(() => {
    if (userSession && userSession.user_id) {
      setUserRole(userSession.user_role); // Set user role
      setUserId(userSession.user_id); // Set user ID
      fetchAllBookings(userSession, {}, 1, limit);
      // Pass userSession to the function
    } else {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (userSession && userSession.user_id) {
      fetchAllBookings(userSession, activeFilters, page, limit); // ✅ Use stored filters
    }
  }, [page]);


  const handleDeleteClick = (bookingId) => {
    setBookingToDelete(bookingId); // Set the booking ID to delete
    setIsDeleteModalOpen(true); // Open the delete confirmation modal
  };

  const isBookingId = (input) => {
    return /^[0-9a-fA-F]{24}$/.test(input); // Assuming MongoDB ObjectID format (24-character hex string)
  };

  const fetchAllBookings = (userSession, filters = {}, pageNumber = page, limitNumber = limit) => {
    setLoading(true);
    const { startDate, endDate, searchInput, status, services, bdmName, paymentmode, paymentStartDate, paymentEndDate } =
      filters;
    const userRole = userSession.user_role;
    const userId = userSession.user_id;

    const params = new URLSearchParams();

    // Dynamic query building
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (status) params.append("status", status);
    if (services) params.append("service", services);
    if (bdmName) params.append("bdmName", bdmName);
    if (paymentmode) params.append("paymentmode", paymentmode);
    if (paymentStartDate) params.append("paymentStartDate", paymentStartDate);
    if (paymentEndDate) params.append("paymentEndDate", paymentEndDate);


    params.append("page", pageNumber);
    params.append("limit", limitNumber);

    params.append("userId", userId);
    params.append("userRole", userRole);

    let url;

    if (searchInput) {
      url = isBookingId(searchInput)
        ? `${apiUrl}/user/${searchInput}?userRole=${userRole}&userId=${userId}`
        : `${apiUrl}/user/?pattern=${searchInput}&userRole=${userRole}&userId=${userId}`;
    } else {
      url = `${apiUrl}/booking/bookings/filter?${params.toString()}`;
    }

    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: `${userSession.token}`,
      },
    })
      .then((response) => {
        if (!response.ok) throw new Error("Network response was not ok");
        return response.json();
      })
      .then((data) => {
        let bookingsData = [];

        // Handle paginated response format
        if (data.bookings && Array.isArray(data.bookings)) {
          bookingsData = data.bookings;
          setTotalPages(data.totalPages || 1);  // Add this state in your component
          setPage(data.currentPage || 1);       // Add this state in your component
        } else if (Array.isArray(data)) {
          bookingsData = data;
        } else if (data && Array.isArray(data.Allbookings)) {
          bookingsData = data.Allbookings;
        }

        if (bookingsData.length === 0) {
          setBookings([]);
        } else {
          const sortedBookings = bookingsData.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setBookings(sortedBookings);
          console.log(sortedBookings);

          try {
            setexelData(jsonToCSV(sortedBookings, selectedFields));
          } catch (error) {
            console.error("Error while converting to CSV:", error);
            enqueueSnackbar("Failed to generate CSV data", { variant: "error" });
          }
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
      });
  };

  const handleDownload = () => {
    if (!canDownloadBookings) {
      enqueueSnackbar("Only director and dev roles can download bookings.", { variant: "warning" });
      return;
    }
    // Show the pop-up when the user clicks the download button
    setOpenPopupD(true);
  };

  const handleFieldSelectionChange = (field) => {
    setSelectedFields((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  const handleDownloadCSV = async () => {
    if (!downloadAll) {
      if (!bookings || bookings.length === 0) {
        enqueueSnackbar("No data available to download!", { variant: "warning" });
        return;
      }

      const csvData = jsonToCSV(bookings, selectedFields);
      downloadCSV(csvData, "bookings_data.csv");
      setOpenPopupD(false);
      return;
    }

    try {
      setLoading(true);
      const userSession = JSON.parse(localStorage.getItem("userSession"));
      const url = `${apiUrl}/booking/all`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: userSession.token,
        },
      });

      if (!response.ok) throw new Error("Failed to fetch all bookings");

      const data = await response.json();

      const allBookings = data.Allbookings || []; // ✅ Access correctly

      if (allBookings.length === 0) {
        enqueueSnackbar("No bookings found for download", { variant: "warning" });
      } else {
        const csvData = jsonToCSV(allBookings, selectedFields);
        downloadCSV(csvData, "all_bookings_data.csv");
        enqueueSnackbar("All bookings downloaded successfully!", { variant: "success" });
      }

    } catch (error) {
      console.error("Download error:", error);
      enqueueSnackbar("Download failed!", { variant: "error" });
    } finally {
      setLoading(false);
      setOpenPopupD(false);
    }
  };


  const handleClosePopup = () => {
    setOpenPopupD(false); // Close the popup without downloading
  };

  const handleResetFilters = () => {
    // Reset the selectedFields to their default values (all true, for example)
    setSelectedFields({
      companyName: true,
      bdmName: true,
      contactNo: true,
      email: true,
      bookingDate: true,
      paymentDate: true,
      totalPayment: true,
      receivedPayment: true,
      afterDisbursement: true,
      remark: true,
      services: true,
      gst: true,
      state: true,
      pan: true,
    });

    // Reset other filter values like search input, date filters, status
    setSearchInput("");
    setStartDate("");
    setEndDate("");
    setSelectedMonth("");
    setStatus("");
    setBdmSearch("");
    setService("");
    setPaymentmode(""); // ✅ Fix added

    setActiveFilters({}); // ✅ Also clear active filters
    setPage(1); // reset to page 1

    // Refetch data without any filters applied
    // Ensure that userSession is available
    const userSession = JSON.parse(localStorage.getItem("userSession"));

    if (userSession && userSession.user_id) {
      // Refetch data without any filters applied
      fetchAllBookings(userSession);
    } else {
      // If userSession is missing, handle it gracefully (maybe show a message or redirect)
      console.log("User session is missing or invalid.");
    }
  };

  // chnages End

  const handleEditClick = (booking, termKey = "") => {
    setEditBooking(termKey ? { ...booking, __editTermKey: termKey } : booking);
    setIsPopupOpen(true);
  };

  const handleDeleteTerm = async (booking, termKey) => {
    const termIndex = TERM_KEYS.indexOf(termKey);
    const laterTermExists = TERM_KEYS.slice(termIndex + 1).some(
      (key) => Number(booking?.[key] || 0) > 0
    );

    if (laterTermExists) {
      enqueueSnackbar("Delete the latest continuation term first.", { variant: "warning" });
      return;
    }

    const termLabel = termKey.replace("_", " ").toUpperCase();
    if (!window.confirm(`Delete ${termLabel}? Its received amount and term sharing will be removed. The booking itself will remain.`)) {
      return;
    }

    try {
      const response = await fetch(`${apiUrl}/booking/editbooking/${booking._id}/terms/${termKey}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "user-role": userSession?.user_role || "",
          "user-name": userSession?.name || "",
          authorization: userSession?.token || "",
        },
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data.message || `Unable to delete ${termLabel}`);

      closeBookingDetails();
      await fetchAllBookings(userSession);
      enqueueSnackbar(data.message || `${termLabel} deleted successfully.`, { variant: "success" });
    } catch (error) {
      enqueueSnackbar(error.message || "Unable to delete the term.", { variant: "error" });
    }
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setEditBooking(null); // Clear the current booking on popup close
    fetchAllBookings(JSON.parse(localStorage.getItem("userSession"))); // Fetch updated bookings
  };

  const confirmDelete = () => {
    if (!bookingToDelete) return;

    fetch(`${apiUrl}/booking/trash/${bookingToDelete}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "user-role": userSession.user_role,
        "user-name": userSession?.name,
        authorization: `${userSession.token}`,
      },
    })
      .then(async (response) => {
        if (!response.ok) {
          const errData = await response.json().catch(() => ({}));
          throw new Error(errData.message || "Error moving the booking to trash");
        }
        setBookings((prev) =>
          prev.filter((booking) => booking._id !== bookingToDelete)
        );
        enqueueSnackbar("Booking moved to trash successfully!", {
          variant: "success",
        });
      })
      .catch((error) => {
        enqueueSnackbar(error.message || "Failed to move booking to trash!", { variant: "error" });
      })
      .finally(() => {
        setIsDeleteModalOpen(false);
        setBookingToDelete(null);
      });
  };


  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setBookingToDelete(null);
  };
  // Function to handle search functionality (by booking ID, company name, date range, and status)

  //After change
  const handleSearch = () => {
    const userSession = JSON.parse(localStorage.getItem("userSession"));
    const filters = {};
    // Date filter logic based on selection

    if (searchInput) {
      filters.searchInput = searchInput;
      setActiveFilters(filters); // ✅ Store filters
      setPage(1);
      fetchAllBookings(userSession, filters, 1, limit);
      return;
    }

    const parsedStartDate = parseFilterDate(startDate);
    const parsedEndDate = parseFilterDate(endDate);

    if ((startDate || endDate) && (!parsedStartDate || !parsedEndDate)) {
      enqueueSnackbar("Please enter dates as DD/MM/YYYY", { variant: "warning" });
      return;
    }

    if (parsedStartDate && parsedEndDate) {
      if (dateType === "booking") {
        filters.startDate = parsedStartDate;
        filters.endDate = parsedEndDate;
      } else if (dateType === "payment") {
        filters.paymentStartDate = parsedStartDate;
        filters.paymentEndDate = parsedEndDate;
      }
    }

    if (bdmSearch) filters.bdmName = bdmSearch;
    if (status) filters.status = status;
    if (paymentmode) filters.paymentmode = paymentmode;
    if (services) filters.services = services;

    setActiveFilters(filters); // ✅ Store filters
    setPage(1);
    fetchAllBookings(userSession, filters, 1, limit);
  };


  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch(); // Trigger search when Enter key is pressed
    }
  };

  const formatDisplayDate = (value) => {
    if (!value) return "N/A";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "N/A";

    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  const upperText = (value) => value ? String(value).toUpperCase() : "N/A";
  const lowerEmail = (value) => value ? String(value).toLowerCase() : "N/A";

  const parseFilterDate = (value) => {
    const raw = String(value || "").trim();
    if (!raw) return "";

    const slashMatch = raw.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (slashMatch) {
      const [, day, month, year] = slashMatch;
      const iso = `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
      const parsed = new Date(iso);
      return !Number.isNaN(parsed.getTime()) && parsed.toISOString().slice(0, 10) === iso ? iso : "";
    }

    const isoMatch = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (isoMatch) return raw;

    return "";
  };

  const formatFilterDate = (isoDate) => {
    const match = String(isoDate || "").match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!match) return isoDate || "";
    const [, year, month, day] = match;
    return `${day}/${month}/${year}`;
  };

  const handleCopy = (booking) => {
    const populatedTermKeys = TERM_KEYS.filter((termKey) => Number(booking?.[termKey] || 0) > 0);
    const termBlocks = populatedTermKeys
      .map((termKey, index) => {
        const info = getTermShareInfo(booking, termKey);
        const sharedLabel = Array.isArray(info.sharedWith) && info.sharedWith.length > 0
          ? info.sharedWith.map((sw) => `${upperText(sw.user_name || usersMap[sw.user_id] || "Coworker")} (${sw.percentage}%)`).join(", ")
          : "Not Shared";
        return `TERM ${index + 1}
Amount: ${Number(booking?.[termKey] || 0).toLocaleString("en-IN")} INR
Payment Date: ${formatDisplayDate(info.paymentDate)}
Payment Mode: ${info.paymentMode}
Created By: ${info.creatorName}
Shared With: ${sharedLabel}`;
      })
      .join("\n\n");

    const richBookingDetails = `
Booking ID: ${booking._id}
Booking Date: ${formatDisplayDate(booking.date)}
Payment Date: ${formatDisplayDate(booking.payment_date)}

Company Name: ${upperText(booking.company_name)}
Contact Person: ${upperText(booking.contact_person)}
Email: ${lowerEmail(booking.email)}
Contact Number: ${booking.contact_no}
Service: ${Array.isArray(booking.services) ? booking.services.join(", ") : booking.services}
Total Amount: ${Number(booking.total_amount || 0).toLocaleString("en-IN")} INR
Received Amount: ${Number(getReceivedAmount(booking)).toLocaleString("en-IN")} INR
Pending Amount: ${(Number(booking.total_amount || 0) - Number(getReceivedAmount(booking))).toLocaleString("en-IN")} INR
Booking Payment Mode: ${booking.bank || "N/A"}

${termBlocks}

BDM Name: ${upperText(booking.bdm)}
Lead Closed By: ${booking.closed_by || "N/A"}
GST No: ${upperText(booking.gst)}
PAN No: ${upperText(booking.pan)}
Notes: ${booking.remark}
After Disbursement: ${booking.after_disbursement}
State: ${booking.state}
Status: ${booking.status}
    `;
    navigator.clipboard.writeText(richBookingDetails).then(() => {
      enqueueSnackbar("Booking details copied to clipboard!", {
        variant: "success",
      });
    });
    return;
    // eslint-disable-next-line no-unreachable
    const bookingDetails = `
      Booking ID: ${booking._id}
      Booking Date: ${formatDisplayDate(booking.date)}
      Payment Date: ${formatDisplayDate(booking.payment_date)}

      Company Name: ${upperText(booking.company_name)}
      Contact Person: ${upperText(booking.contact_person)}
      Email: ${lowerEmail(booking.email)}
      Contact Number: ${booking.contact_no}
      Service: ${booking.services}
      Total Amount: ${booking.total_amount}₹
      Received Amount: ${booking.term_1 + booking.term_2 + booking.term_3}₹
      Pending Amount: ${booking.total_amount -
      (booking.term_1 + booking.term_2 + booking.term_3)
      }₹
      Term ${booking.term_1 ? "1" : booking.term_2 ? "2" : booking.term_3 ? "3" : ""
      }:  ${booking.term_1 || booking.term_2 || booking.term_3}
      Bdm name : ${upperText(booking.bdm)}
      Lead Closed By: ${booking.closed_by || "N/A"}
      GST No: ${upperText(booking.gst)}
      PAN No: ${upperText(booking.pan)}
      Bank Name: ${booking.bank}
      Notes: ${booking.remark}
      After Disbursement:${booking.after_disbursement}
      State:${booking.state}
      Status: ${booking.status}
    `;
    navigator.clipboard.writeText(bookingDetails).then(() => {
      enqueueSnackbar("Booking details copied to clipboard!", {
        variant: "success",
      });
    });
  };

  // Document handling functions
  const handleViewDocuments = async (booking) => {
    setSelectedBookingDocs(booking);
    setDocumentsDialogOpen(true);
    setDocsLoading(true);
    try {
      const res = await fetch(`${apiUrl}/booking-documents/booking/${booking._id}`, {
        headers: { authorization: userSession.token }
      });
      if (res.ok) {
        const docs = await res.json();
        const paymentProofDocs = (
          Array.isArray(booking?.payment_proofs) && booking.payment_proofs.length > 0
            ? booking.payment_proofs
            : booking?.payment_proof_url
              ? [{
                  url: booking.payment_proof_url,
                  file_name: booking.payment_proof_file_name || "payment-proof",
                  mime_type: booking.payment_proof_mime_type || "",
                }]
              : []
        ).map((proof, index) => ({
          _id: `payment-proof-${booking._id}-${index}`,
          documentType: "payment_proof",
          fileName: proof.file_name || `payment-proof-${index + 1}`,
          fileUrl: proof.url,
          mimeType: proof.mime_type || "",
          fileSize: null,
          uploadedBy: booking.user_id,
          uploadedByName: booking.bdm || "Payment Proof",
          createdAt: booking.payment_date || booking.date,
          isSyntheticProof: true,
        }));
        setBookingDocuments([...paymentProofDocs, ...docs]);
      } else {
        setBookingDocuments([]);
      }
    } catch (error) {
      console.error('Error fetching documents:', error);
      setBookingDocuments([]);
    } finally {
      setDocsLoading(false);
    }
  };

  const handleCloseDocumentsDialog = () => {
    setDocumentsDialogOpen(false);
    setSelectedBookingDocs(null);
    setBookingDocuments([]);
  };

  const downloadDocument = (doc) => {
    if (!doc || !doc.fileUrl) {
      enqueueSnackbar('Invalid document or no file available', { variant: 'error' });
      return;
    }
    window.open(doc.fileUrl, '_blank');
  };

  const handleDeleteDocument = async (doc) => {
    if (!doc || !doc._id) {
      enqueueSnackbar('Invalid document', { variant: 'error' });
      return;
    }

    const canDelete = isHigherAuthority(userSession) || 
                     canAccessFeature(userSession, 'manage_documents') ||
                     canAccessFeature(userSession, 'edit_documents');
    
    if (!canDelete) {
      enqueueSnackbar('You do not have permission to delete documents', { variant: 'warning' });
      return;
    }

    if (!window.confirm('Are you sure you want to delete this document?')) return;

    try {
      const res = await fetch(`${apiUrl}/booking-documents/${doc._id}`, {
        method: 'DELETE',
        headers: { authorization: userSession.token }
      });

      if (res.ok) {
        enqueueSnackbar('Document deleted successfully', { variant: 'success' });
        handleViewDocuments(selectedBookingDocs);
      } else {
        enqueueSnackbar('Failed to delete document', { variant: 'error' });
      }
    } catch (error) {
      enqueueSnackbar('Error deleting document', { variant: 'error' });
    }
  };

  const formatFileSize = (bytes) => {
    if (!bytes) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  if (loading)
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh", // Ensures the container takes the full height of the viewport
        }}
      >
        <Loader />
      </div>
    );

  return (
    <div className="history-page" style={{
      backgroundColor: mode === 'light' ? '#f1f5f9' : '#020617',
      color: mode === 'light' ? '#0f172a' : '#e5e7eb',
      minHeight: '100vh',
      transition: 'all 0.3s ease'
    }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: { xs: 'flex-start', md: 'center' },
          flexDirection: { xs: 'column', md: 'row' },
          gap: { xs: 1.25, md: 0 },
          mb: 2,
        }}
      >
        <h2
          className="history-header"
          style={{
            color: mode === 'light' ? '#0f172a' : '#ffffff',
            margin: 0,
            fontSize: 'clamp(1.15rem, 3.7vw, 1.8rem)',
            lineHeight: 1.2,
          }}
        >
          {shareFilter === "SharedByMe" ? "Shared Bookings (By Me)" : shareFilter === "SharedWithMe" ? "Shared Bookings (With Me)" : "All Bookings"}
        </h2>
        <Box sx={{ display: 'flex', gap: 0.8, flexWrap: 'wrap' }}>
          <Button
            variant={shareFilter === "All" ? "contained" : "outlined"}
            size="small"
            onClick={() => setShareFilter("All")}
            sx={{
              borderRadius: '999px',
              textTransform: 'none',
              minWidth: 0,
              px: { xs: 1.15, md: 1.5 },
              py: { xs: 0.3, md: 0.45 },
              fontSize: { xs: '0.72rem', md: '0.78rem' },
              lineHeight: 1.1,
            }}
          >
            All Bookings
          </Button>
          <Button
            variant={shareFilter === "SharedByMe" ? "contained" : "outlined"}
            size="small"
            onClick={() => setShareFilter("SharedByMe")}
            sx={{
              borderRadius: '999px',
              textTransform: 'none',
              minWidth: 0,
              px: { xs: 1.15, md: 1.5 },
              py: { xs: 0.3, md: 0.45 },
              fontSize: { xs: '0.72rem', md: '0.78rem' },
              lineHeight: 1.1,
            }}
          >
            Shared By Me
          </Button>
          <Button
            variant={shareFilter === "SharedWithMe" ? "contained" : "outlined"}
            size="small"
            onClick={() => setShareFilter("SharedWithMe")}
            sx={{
              borderRadius: '999px',
              textTransform: 'none',
              minWidth: 0,
              px: { xs: 1.15, md: 1.5 },
              py: { xs: 0.3, md: 0.45 },
              fontSize: { xs: '0.72rem', md: '0.78rem' },
              lineHeight: 1.1,
            }}
          >
            Shared With Me
          </Button>
        </Box>
      </Box>

      <section className="history-filter-panel" aria-label="Booking filters">
        <div className="history-filter-header">
          <div>
            <h2>Find Bookings</h2>
            <p>Search directly, or combine filters below.</p>
          </div>
          <div className="history-filter-actions">
            <button className="search-button" onClick={handleSearch}>
              <i className="fa-solid fa-magnifying-glass"></i>
              Search
            </button>
            <button className="reset-button" onClick={handleResetFilters}>
              Reset
            </button>
          </div>
        </div>

        <div className="history-search-row">
          <label className="filter-field filter-field-wide">
            <span>Universal Search</span>
            <input
              type="text"
              className="history-filter-input"
              placeholder="Employee, client, booking ID, service, status..."
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              onKeyDown={handleKeyPress}
            />
          </label>
        </div>

        <div className="history-filter-grid">
          <label className="filter-field">
            <span>Date Type</span>
            <select className="history-filter-input" value={dateType} onChange={(e) => setDateType(e.target.value)}>
              <option value="booking">Booking Date</option>
              <option value="payment">Payment Date</option>
            </select>
          </label>

          <label className="filter-field">
            <span>From Date</span>
            <input
              type="text"
              inputMode="numeric"
              className="history-filter-input"
              placeholder="DD/MM/YYYY"
              value={formatFilterDate(startDate)}
              onChange={(e) => setStartDate(e.target.value)}
              onKeyDown={handleKeyPress}
            />
          </label>

          <label className="filter-field">
            <span>To Date</span>
            <input
              type="text"
              inputMode="numeric"
              className="history-filter-input"
              placeholder="DD/MM/YYYY"
              value={formatFilterDate(endDate)}
              onChange={(e) => setEndDate(e.target.value)}
              onKeyDown={handleKeyPress}
            />
          </label>

          <label className="filter-field">
            <span>Quick Month</span>
            <input
              type="month"
              className="history-filter-input"
              value={selectedMonth}
              onChange={(e) => {
                setSelectedMonth(e.target.value);
                if (!e.target.value) return;
                const [year, month] = e.target.value.split('-').map(Number);
                const first = `${e.target.value}-01`;
                const lastDate = new Date(year, month, 0).getDate();
                setStartDate(formatFilterDate(first));
                setEndDate(formatFilterDate(`${e.target.value}-${String(lastDate).padStart(2, '0')}`));
              }}
            />
          </label>

          <label className="filter-field">
            <span>BDM Name</span>
            <input
              type="text"
              className="history-filter-input"
              placeholder="Employee name"
              value={bdmSearch}
              onChange={(e) => setBdmSearch(e.target.value)}
              onKeyDown={handleKeyPress}
            />
          </label>

          <label className="filter-field">
            <span>Payment Method</span>
            <select className="history-filter-input" value={paymentmode} onChange={(e) => setPaymentmode(e.target.value)}>
              <option value="">Any method</option>
              {ALL_PAYMENT_METHODS.map((paymentMethod) => (
                <option key={paymentMethod} value={paymentMethod}>{paymentMethod}</option>
              ))}
            </select>
          </label>

          <label className="filter-field">
            <span>Status</span>
            <select className="history-filter-input" value={status} onChange={(e) => setStatus(e.target.value)}>
              <option value="">Any status</option>
              <option value="Pending">Pending</option>
              <option value="In Progress">In Progress</option>
              <option value="Completed">Completed</option>
            </select>
          </label>

          <label className="filter-field">
            <span>Service</span>
            <select className="history-filter-input" value={services} onChange={(e) => setService(e.target.value)}>
              <option value="">Any service</option>
              {servicesList.map((service) => (
                <option key={service.value || service.label} value={service.value || service.label}>{service.label || service.value}</option>
              ))}
            </select>
          </label>
        </div>
      </section>
      <div className="booking-list">
        {bookings
          .filter(b => {
            if (shareFilter === "All") return true;
            if (shareFilter === "SharedByMe") {
              return Array.isArray(b.shared_with) && b.shared_with.length > 0 && b.user_id === userId;
            }
            if (shareFilter === "SharedWithMe") {
              return Array.isArray(b.shared_with) && b.shared_with.some(sw => sw.user_id === userId);
            }
            return true;
          })
          .length > 0 ? (
          bookings
            .filter(b => {
              if (shareFilter === "All") return true;
              if (shareFilter === "SharedByMe") {
                return Array.isArray(b.shared_with) && b.shared_with.length > 0 && b.user_id === userId;
              }
              if (shareFilter === "SharedWithMe") {
                return Array.isArray(b.shared_with) && b.shared_with.some(sw => sw.user_id === userId);
              }
              return true;
            })
            .map((booking, bookingIndex) => {
              const receivedAmount = getReceivedAmount(booking);
              const visibleContinuationTerms = TERM_KEYS.slice(1).filter((termKey) => Number(booking?.[termKey] || 0) > 0);
              const term1ShareInfo = getTermShareInfo(booking, "term_1");
              const term2Visible = Number(booking.term_2 || 0) > 0;
              const term3Visible = Number(booking.term_3 || 0) > 0;
              const term2ShareInfo = getTermShareInfo(booking, "term_2");
              const term3ShareInfo = getTermShareInfo(booking, "term_3");
              const primaryTone = getBookingTone(bookingIndex, "primary");
              const term2Tone = getBookingTone(bookingIndex, "term_2");
              const term3Tone = getBookingTone(bookingIndex, "term_3");

              return (
              <div className="booking-stack" key={booking._id} data-tone-group={Math.floor(bookingIndex / 2) % cardTones.length}>
              <div className="booking-item booking-item-primary" style={{
                ...primaryTone,
                position: 'relative'
              }}>
                {visibleContinuationTerms.length > 0 && (
                  <div style={{
                    position: 'absolute',
                    top: '10px',
                    right: '10px',
                    background: mode === 'light' ? '#111827' : '#f97316',
                    color: '#fff',
                    padding: '4px 8px',
                    borderRadius: '999px',
                    fontSize: '11px',
                    fontWeight: 700,
                    zIndex: 1,
                  }}>
                    MULTIPLE TERMS
                  </div>
                )}
                <div className="booking-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    {getBookingRefundableLabel(booking) && (
                      <Chip size="small" color="warning" label={getBookingRefundableLabel(booking)} />
                    )}
                  </div>
                  <button
                    className="copy-button"
                    onClick={() => handleCopy(booking)}
                  >
                    <ContentCopyOutlinedIcon fontSize="small" />
                  </button>
                </div>
                <div className="booking-hero">
                  <div>
                    <p className="booking-overline">Company</p>
                    <h3 className="booking-company-name">{upperText(booking.company_name)}</h3>
                    <p className="booking-subtitle">
                      {upperText(booking.contact_person)} • {lowerEmail(booking.email)}
                    </p>
                  </div>
                  <div className="booking-hero-side">
                    <span className="booking-total-label">Total Amount</span>
                    <strong className="booking-total-value">{Number(booking.total_amount || 0)} ₹</strong>
                  </div>
                </div>
                <div className="booking-metrics">
                  {renderDetailItem("Received", `${receivedAmount} ₹`, { highlight: true })}
                  {renderDetailItem("Pending", `${Number(booking.total_amount || 0) - receivedAmount} ₹`)}
                  {renderDetailItem("Booking Date", formatDisplayDate(booking.date))}
                  {renderDetailItem("Creator", term1ShareInfo.creatorName)}
                  {renderDetailItem("Payment Mode", booking.bank || "N/A")}
                </div>
                <table className="booking-table">
                  <tbody>
                    <tr>
                      <td>
                        <strong>Booking Date</strong>
                      </td>
                      <td>
                        <span className="colon-bold">:</span> &nbsp;&nbsp;
                        {formatDisplayDate(booking.date)}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Payment Date</strong>
                      </td>
                      <td>
                        <span className="colon-bold">:</span> &nbsp;&nbsp;
                        {formatDisplayDate(booking.payment_date)}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Booking ID </strong>
                      </td>
                      <td style={{ textTransform: "uppercase" }}>
                        <span className="colon-bold">:</span> &nbsp;&nbsp;
                        {booking._id}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Company Name </strong>
                      </td>
                      <td>
                        <span className="colon-bold">:</span> &nbsp;&nbsp;
                        <strong>{upperText(booking.company_name)}</strong>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Contact Person </strong>
                      </td>
                      <td>
                        <span className="colon-bold">:</span> &nbsp;&nbsp;
                        {upperText(booking.contact_person)}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Email </strong>
                      </td>
                      <td>
                        <span className="colon-bold">:</span> &nbsp;&nbsp;{" "}
                        {lowerEmail(booking.email)}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Contact Number</strong>
                      </td>
                      <td>
                        <span className="colon-bold">:</span> &nbsp;&nbsp;
                        {booking.contact_no}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Service</strong>
                      </td>
                      <td>
                        <span className="colon-bold">:</span>
                        &nbsp;&nbsp;
                        <strong>
                          {Array.isArray(booking.services)
                            ? booking.services.join(", ")
                            : booking.services || "N/A"}
                        </strong>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <strong>Terms</strong>
                      </td>
                      <td>
                        <span className="colon-bold">:</span> &nbsp;&nbsp;
                        {TERM_KEYS
                          .filter((termKey) => Number(booking?.[termKey] || 0) > 0)
                          .map((termKey) => `Term ${TERM_KEYS.indexOf(termKey) + 1}: ${Number(booking?.[termKey] || 0).toLocaleString("en-IN")}`)
                          .join(" | ") || "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Total Amount </strong>
                      </td>
                      <td>
                        <span className="colon-bold">:</span> &nbsp;&nbsp;
                        INR {Number(booking.total_amount || 0).toLocaleString("en-IN")}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Received Amount </strong>
                      </td>
                      <td>
                        <span className="colon-bold">:</span> &nbsp;&nbsp;
                        INR {Number(receivedAmount || 0).toLocaleString("en-IN")}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Pending Amount </strong>
                      </td>
                      <td>
                        <span className="colon-bold">:</span> &nbsp;&nbsp;
                        INR {Number(Number(booking.total_amount || 0) - receivedAmount).toLocaleString("en-IN")}
                      </td>
                    </tr>
                    {booking.refund_adjustments?.length > 0 && (
                      <tr>
                        <td>
                          <strong style={{ color: '#ef4444' }}>Refunded Amount</strong>
                        </td>
                        <td>
                          <span className="colon-bold">:</span> &nbsp;&nbsp;
                          <span style={{ color: '#ef4444', fontWeight: 'bold' }}>
                            {booking.refund_adjustments.reduce((sum, r) => sum + (Number(r.amount) || 0), 0)}₹
                          </span>
                        </td>
                      </tr>
                    )}
                    <tr>
                      <td>
                        <strong>Scorecard Amount</strong>
                      </td>
                      <td>
                        <span className="colon-bold">:</span>&nbsp;&nbsp;
                        {Array.isArray(booking.scorecard) ? (
                          <ul className="pl-2 list-disc">
                            {booking.scorecard.map((person, i) => (
                              <li key={i}>
                                <strong>{person.name}</strong> – {person.percentage}% – ₹{person.score_amount}
                              </li>
                            ))}
                          </ul>
                        ) : booking.scorecard ? (
                          <>
                            <strong>{booking.scorecard.name}</strong> – {booking.scorecard.percentage}% – ₹{booking.scorecard.score_amount}
                          </>
                        ) : (
                          "N/A"
                        )}
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <strong>Shared With</strong>
                      </td>
                      <td>
                        <span className="colon-bold">:</span>&nbsp;&nbsp;
                        {Array.isArray(booking.shared_with) && booking.shared_with.length > 0 ? (
                          <ul style={{ paddingLeft: '20px', margin: 0 }}>
                            {booking.shared_with.map((sw, idx) => (
                              <li key={idx}>
                                <strong>{upperText(sw.user_name || usersMap[sw.user_id] || "Coworker")}</strong> – {sw.percentage}%
                              </li>
                            ))}
                          </ul>
                        ) : (
                          "Not Shared"
                        )}
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <strong>GST </strong>
                      </td>
                      <td>
                        <span className="colon-bold">:</span> &nbsp;&nbsp;
                        {upperText(booking.gst)}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>PAN No </strong>
                      </td>
                      <td>
                        <span className="colon-bold">:</span> &nbsp;&nbsp;
                        {upperText(booking.pan)}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Bank Name </strong>
                      </td>
                      <td>
                        <span className="colon-bold">:</span> &nbsp;&nbsp;
                        {booking.bank}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Bdm Name </strong>
                      </td>
                      <td>
                        <span className="colon-bold">:</span> &nbsp;&nbsp;
                        <strong>{upperText(booking.bdm)}</strong>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Closed By </strong>
                      </td>
                      <td>
                        <span className="colon-bold">:</span> &nbsp;&nbsp;
                        {booking.closed_by || "N/A"}
                      </td>
                    </tr>

                    <tr>
                      <td><strong>Update History</strong></td>
                      <td>
                        <span className="colon-bold">:</span>&nbsp;&nbsp;
                        {booking.updatedhistory && booking.updatedhistory.length > 0 ? (
                          <ul className="pl-4">
                            {booking.updatedhistory.map((update, updateIndex) => (
                              <li key={update._id || updateIndex} className="mb-4">
                                <strong>{update.updatedBy}</strong> on{" "}
                                {new Date(update.updatedAt).toLocaleString()}
                                <br />
                                <button
                                  className="mt-2 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                                  onClick={() => handleViewDetailsClick(bookings.indexOf(booking), updateIndex)}

                                >
                                  View Details
                                </button>
                              </li>
                            ))}
                          </ul>
                        ) : (
                          "N/A"
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>State </strong>
                      </td>
                      <td>
                        <span className="colon-bold">:</span> &nbsp;&nbsp;
                        {booking.state}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>After Fund disbursement </strong>
                      </td>
                      <td>
                        <span className="colon-bold">:</span> &nbsp;&nbsp;
                        {booking.after_disbursement || "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Notes</strong>
                      </td>
                      <td>
                        <span className="colon-bold">:</span> &nbsp;&nbsp;
                        {booking.remark}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Status</strong>
                      </td>
                      <td>
                        <span className="colon-bold">:</span> &nbsp;&nbsp;
                        <span
                          className={
                            booking.status === "Pending"
                              ? "status-pending"
                              : booking.status === "In Progress"
                                ? "status-in-progress"
                                : booking.status === "Completed"
                                  ? "status-completed"
                                  : ""
                          }
                        >
                          {booking.status}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div className="booking-footer booking-footer-split">
                  <div className="booking-footer-left">
                    <button
                      className="details-link"
                      onClick={() => openBookingDetails(booking)}
                    >
                      <VisibilityOutlinedIcon fontSize="small" />
                      View Details
                    </button>
                    {visibleContinuationTerms.map((termKey) => {
                      const termNumber = TERM_KEYS.indexOf(termKey) + 1;
                      return (
                        <button
                          key={termKey}
                          className="term-toggle-button"
                          onClick={() => toggleTermCard(booking._id, termKey)}
                        >
                          {isTermExpanded(booking._id, termKey) ? `Hide Term ${termNumber}` : `View Term ${termNumber}`}
                        </button>
                      );
                    })}
                  </div>
                  <div className="booking-footer-right">
                  <button
                    className="view-docs-link"
                    onClick={() => handleViewDocuments(booking)}
                    style={{
                      backgroundColor: '#8b5cf6',
                      color: 'white',
                      border: 'none',
                      padding: '6px 12px',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      fontSize: '0.85rem',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '4px'
                    }}
                  >
                    <FolderOpenIcon fontSize="small" />
                    Documents
                  </button>

                  {["admin", "senior admin", "super admin", "director", "dev", "srdev", "sr dev"].includes((userRole || "").toLowerCase()) && (
                      <button
                        className="edit-link"
                        onClick={() => handleEditClick(booking)}
                      >
                        Edit
                      </button>
                    )}

                  {["dev", "srdev"].includes(userRole) && (
                    <button
                      className="delete-link"
                      onClick={() => handleDeleteClick(booking._id)}
                    >
                      Delete
                    </button>
                  )}
                  </div>
                </div>
              </div>
              {term2Visible && isTermExpanded(booking._id, "term_2") && (
                <div
                  className="booking-item booking-item-term"
                  style={term2Tone}
                >
                  <div className="booking-section-header">
                    <h4>Continuation Card</h4>
                    <span>Term 2</span>
                  </div>
                  <div className="booking-details-grid">
                    {renderDetailItem("Company", upperText(booking.company_name))}
                    {renderDetailItem("Term Amount", `${getTermAmount(booking, "term_2")} ₹`, { highlight: true })}
                    {renderDetailItem("Payment Date", formatDisplayDate(term2ShareInfo.paymentDate))}
                    {renderDetailItem("Payment Mode", term2ShareInfo.paymentMode)}
                    {renderDetailItem("Created By", term2ShareInfo.creatorName)}
                    {renderDetailItem("Services", Array.isArray(booking.services) ? booking.services.join(", ") : (booking.services || "N/A"))}
                    {renderDetailItem("Shared With", renderSharedWithList(term2ShareInfo.sharedWith))}
                  </div>
                </div>
              )}
              {term3Visible && isTermExpanded(booking._id, "term_3") && (
                <div
                  className="booking-item booking-item-term"
                  style={term3Tone}
                >
                  <div className="booking-section-header">
                    <h4>Continuation Card</h4>
                    <span>Term 3</span>
                  </div>
                  <div className="booking-details-grid">
                    {renderDetailItem("Company", upperText(booking.company_name))}
                    {renderDetailItem("Term Amount", `${getTermAmount(booking, "term_3")} ₹`, { highlight: true })}
                    {renderDetailItem("Payment Date", formatDisplayDate(term3ShareInfo.paymentDate))}
                    {renderDetailItem("Payment Mode", term3ShareInfo.paymentMode)}
                    {renderDetailItem("Created By", term3ShareInfo.creatorName)}
                    {renderDetailItem("Services", Array.isArray(booking.services) ? booking.services.join(", ") : (booking.services || "N/A"))}
                    {renderDetailItem("Shared With", renderSharedWithList(term3ShareInfo.sharedWith))}
                  </div>
                </div>
              )}
              </div>
            );
            })
        ) : (
          <p>No bookings found for the selected filters.</p>
        )}
      </div>

      <Dialog open={Boolean(selectedBookingDetails)} onClose={closeBookingDetails} maxWidth="md" fullWidth>
        <DialogTitle>
          Booking Details
          <IconButton onClick={closeBookingDetails} sx={{ position: "absolute", right: 8, top: 8 }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {selectedBookingDetails && (
            <Box sx={{ display: "grid", gap: 1.25 }}>
              <Typography variant="h6" sx={{ fontWeight: 800 }}>
                {upperText(selectedBookingDetails.company_name)}
              </Typography>
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: { xs: "1fr", sm: "repeat(2, minmax(0, 1fr))" },
                  gap: 1.1,
                }}
              >
                {[
                  ["Booking ID", selectedBookingDetails._id],
                  ["Booking Date", formatDisplayDate(selectedBookingDetails.date)],
                  ["Payment Date", formatDisplayDate(selectedBookingDetails.payment_date)],
                  ["Contact Person", upperText(selectedBookingDetails.contact_person)],
                  ["Email", lowerEmail(selectedBookingDetails.email)],
                  ["Contact Number", selectedBookingDetails.contact_no || "N/A"],
                  ["Services", Array.isArray(selectedBookingDetails.services) ? selectedBookingDetails.services.join(", ") : selectedBookingDetails.services || "N/A"],
                  ["Total Amount", `INR ${Number(selectedBookingDetails.total_amount || 0).toLocaleString("en-IN")}`],
                  ["Received Amount", `INR ${getReceivedAmount(selectedBookingDetails).toLocaleString("en-IN")}`],
                  ["Pending Amount", `INR ${(Number(selectedBookingDetails.total_amount || 0) - getReceivedAmount(selectedBookingDetails)).toLocaleString("en-IN")}`],
                  ["Creator / BDM", upperText(selectedBookingDetails.bdm)],
                  ["Closed By", selectedBookingDetails.closed_by || "N/A"],
                  ["GST", upperText(selectedBookingDetails.gst)],
                  ["PAN", upperText(selectedBookingDetails.pan)],
                  ["Payment Mode", selectedBookingDetails.bank || "N/A"],
                  ["State", selectedBookingDetails.state || "N/A"],
                  ["After Disbursement", selectedBookingDetails.after_disbursement || "N/A"],
                  ["Notes", selectedBookingDetails.remark || "N/A"],
                  ["Shared With", Array.isArray(selectedBookingDetails.shared_with) && selectedBookingDetails.shared_with.length > 0 ? selectedBookingDetails.shared_with.map((sw) => `${upperText(sw.user_name || usersMap[sw.user_id] || "Coworker")} - ${sw.percentage}%`).join(", ") : "Not Shared"],
                ].map(([label, value]) => (
                  <Paper key={label} variant="outlined" sx={{ p: 1.25, borderRadius: "8px" }}>
                    <Typography variant="caption" sx={{ color: "text.secondary", textTransform: "uppercase", fontWeight: 700 }}>
                      {label}
                    </Typography>
                    <Typography sx={{ mt: 0.35, fontWeight: 700 }}>{value}</Typography>
                  </Paper>
                ))}
              </Box>

              <Typography variant="subtitle1" sx={{ fontWeight: 800, mt: 1 }}>
                Terms
              </Typography>
              <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "repeat(3, minmax(0, 1fr))" }, gap: 1.1 }}>
                {TERM_KEYS.filter((termKey) => Number(selectedBookingDetails?.[termKey] || 0) > 0).map((termKey) => {
                  const info = getTermShareInfo(selectedBookingDetails, termKey);
                  return (
                    <Paper key={termKey} variant="outlined" sx={{ p: 1.25, borderRadius: "8px" }}>
                      <Typography sx={{ fontWeight: 800, mb: 0.5 }}>{termKey.replace("_", " ").toUpperCase()}</Typography>
                      <Typography variant="body2"><strong>Amount:</strong> INR {Number(selectedBookingDetails?.[termKey] || 0).toLocaleString("en-IN")}</Typography>
                      <Typography variant="body2"><strong>Payment Date:</strong> {formatDisplayDate(info.paymentDate)}</Typography>
                      <Typography variant="body2"><strong>Payment Mode:</strong> {info.paymentMode}</Typography>
                      <Typography variant="body2"><strong>Created By:</strong> {info.creatorName}</Typography>
                      <Typography variant="body2"><strong>Shared With:</strong> {Array.isArray(info.sharedWith) && info.sharedWith.length > 0 ? info.sharedWith.map((sw) => `${upperText(sw.user_name || usersMap[sw.user_id] || "Coworker")} - ${sw.percentage}%`).join(", ") : "Not Shared"}</Typography>
                      <Box sx={{ display: "flex", gap: 0.75, flexWrap: "wrap", mt: 1 }}>
                        {["admin", "senior admin", "super admin", "director", "dev", "srdev", "sr dev"].includes((userRole || "").toLowerCase()) && (
                          <Button
                            size="small"
                            variant="outlined"
                            sx={{ borderRadius: "8px" }}
                            onClick={() => {
                              closeBookingDetails();
                              handleEditClick(selectedBookingDetails, termKey);
                            }}
                          >
                            Edit {termKey.replace("_", " ").toUpperCase()}
                          </Button>
                        )}
                        {termKey !== "term_1" && canDeleteContinuationTerms && (
                          <Button
                            size="small"
                            color="error"
                            variant="outlined"
                            sx={{ borderRadius: "8px" }}
                            onClick={() => handleDeleteTerm(selectedBookingDetails, termKey)}
                          >
                            Delete {termKey.replace("_", " ").toUpperCase()}
                          </Button>
                        )}
                      </Box>
                    </Paper>
                  );
                })}
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={closeBookingDetails}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* Modal for View Details */}
      <Dialog open={openDialogInfo.bookingIndex !== null} onClose={handleCloseModal}>
        <DialogTitle>Update Details</DialogTitle>
        <DialogContent>
          {openDialogInfo.bookingIndex !== null &&
            openDialogInfo.updateIndex !== null &&
            bookings[openDialogInfo.bookingIndex]?.updatedhistory?.[openDialogInfo.updateIndex] && (
              <>
                <h4>{bookings[openDialogInfo.bookingIndex].updatedhistory[openDialogInfo.updateIndex].updatedBy}</h4>
                <p><strong>Note:</strong> {bookings[openDialogInfo.bookingIndex].updatedhistory[openDialogInfo.updateIndex].note || "N/A"}</p>
                <div>
                  <strong>Changes:</strong>
                  <ul>
                    {getVisibleHistoryChanges(bookings[openDialogInfo.bookingIndex].updatedhistory[openDialogInfo.updateIndex].changes).map(([field, value], idx) => (
                      <li key={idx}>
                        <strong>{field}</strong>: <span style={{ color: "red" }}>{formatHistoryValue(value.old)}</span> &rarr; <span style={{ color: "green" }}>{formatHistoryValue(value.new)}</span>
                      </li>
                    ))}
                    {getVisibleHistoryChanges(bookings[openDialogInfo.bookingIndex].updatedhistory[openDialogInfo.updateIndex].changes).length === 0 && (
                      <li>No actual field changes recorded.</li>
                    )}
                  </ul>
                </div>
              </>
            )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <DeleteConfirmationModal
        isOpen={isDeleteModalOpen}
        onClose={closeDeleteModal}
        onConfirm={confirmDelete}
      />
      {canDownloadBookings && (
        <button className="floating-download-button" onClick={handleDownload}>
          <i className="fa-solid fa-download"></i>
        </button>
      )}

      {/* Changed Code */}
      <Dialog open={openPopupD} onClose={handleClosePopup}>
        <DialogTitle>Select Fields to Download</DialogTitle>
        <DialogContent>
          {/* List of checkboxes for field selection */}
          <FormControlLabel
            control={
              <Checkbox
                checked={selectedFields.companyName}
                onChange={() => handleFieldSelectionChange("companyName")}
                color="primary"
              />
            }
            label="Company Name"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={selectedFields.bdmName}
                onChange={() => handleFieldSelectionChange("bdmName")}
                color="primary"
              />
            }
            label="BDM Name"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={selectedFields.contactNo}
                onChange={() => handleFieldSelectionChange("contactNo")}
                color="primary"
              />
            }
            label="Contact No."
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={selectedFields.email}
                onChange={() => handleFieldSelectionChange("email")}
                color="primary"
              />
            }
            label="Email"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={selectedFields.bookingDate}
                onChange={() => handleFieldSelectionChange("bookingDate")}
                color="primary"
              />
            }
            label="Booking Date"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={selectedFields.paymentDate}
                onChange={() => handleFieldSelectionChange("paymentDate")}
                color="primary"
              />
            }
            label="Payment Date"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={selectedFields.totalPayment}
                onChange={() => handleFieldSelectionChange("totalPayment")}
                color="primary"
              />
            }
            label="Total Payment"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={selectedFields.receivedPayment}
                onChange={() => handleFieldSelectionChange("receivedPayment")}
                color="primary"
              />
            }
            label="Received Payment"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={selectedFields.afterDisbursement}
                onChange={() => handleFieldSelectionChange("afterDisbursement")}
                color="primary"
              />
            }
            label="After Disbursement:1%"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={selectedFields.remark}
                onChange={() => handleFieldSelectionChange("remark")}
                color="primary"
              />
            }
            label="Remark"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={selectedFields.services}
                onChange={() => handleFieldSelectionChange("services")}
                color="primary"
              />
            }
            label="Services"
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={selectedFields.termType}
                onChange={() => handleFieldSelectionChange("termType")}
                color="primary"
              />
            }
            label="Term Type"
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={selectedFields.gst}
                onChange={() => handleFieldSelectionChange("gst")}
                color="primary"
              />
            }
            label="GST"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={selectedFields.state}
                onChange={() => handleFieldSelectionChange("state")}
                color="primary"
              />
            }
            label="State"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={selectedFields.pan}
                onChange={() => handleFieldSelectionChange("pan")}
                color="primary"
              />
            }
            label="PAN"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={downloadAll}
                onChange={() => setDownloadAll(!downloadAll)} // Toggle value
                color="primary"
              />
            }
            label="Download all bookings (ignore current filters & pagination)"
          />

        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosePopup} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDownloadCSV} color="primary">
            Download
          </Button>
        </DialogActions>
      </Dialog>
      {/* changed code End */}
      <div className="total-bookings">
        Total Bookings: {isAdminView ? bookings.length : bookings.filter((booking) => String(booking.user_id) === String(userId)).length}
      </div>

      <div className="pagination-controls">
        <button
          disabled={page <= 1 || !!searchInput}
          onClick={() => setPage(page - 1)}
        >
          Previous
        </button>

        <span>Page {page} of {totalPages}</span>

        <button
          disabled={page >= totalPages || !!searchInput}
          onClick={() => setPage(page + 1)}
        >
          Next
        </button>
      </div>


      {isPopupOpen && (
        <Popup isOpen={isPopupOpen} onClose={closePopup}>
          {editBooking ? (
            <EditBooking
              initialData={editBooking} // Pass the booking data to be edited
              onClose={closePopup} // Callback to close popup after form submission
            />
          ) : (
            <AddBooking onClose={closePopup} /> // Render AddBooking if creating new booking
          )}
        </Popup>
      )}

      {/* Documents Dialog */}
      <Dialog 
        open={documentsDialogOpen} 
        onClose={handleCloseDocumentsDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          Documents - {selectedBookingDocs?.company_name}
          <IconButton
            onClick={handleCloseDocumentsDialog}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {docsLoading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
              <Loader />
            </Box>
          ) : bookingDocuments.length === 0 ? (
            <Typography color="text.secondary" align="center" sx={{ py: 4 }}>
              No documents found for this booking.
            </Typography>
          ) : (
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Type</TableCell>
                    <TableCell>File Name</TableCell>
                    <TableCell>Size</TableCell>
                    <TableCell>Uploaded By</TableCell>
                    <TableCell>Date</TableCell>
                    <TableCell align="right">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {bookingDocuments.map((doc) => (
                    <TableRow key={doc._id}>
                      <TableCell>
                        <Chip
                          label={doc.documentType.replace('_', ' ').toUpperCase()}
                          size="small"
                          sx={{
                            bgcolor: 
                              doc.documentType === 'payment_proof' ? '#0ea5e920' :
                              doc.documentType === 'agreement' ? '#8b5cf620' :
                              doc.documentType === 'pitch_deck' ? '#06b6d420' :
                              doc.documentType === 'dpr' ? '#f59e0b20' :
                              doc.documentType === 'application' ? '#10b98120' :
                              '#64748b20',
                            color:
                              doc.documentType === 'payment_proof' ? '#0284c7' :
                              doc.documentType === 'agreement' ? '#8b5cf6' :
                              doc.documentType === 'pitch_deck' ? '#06b6d4' :
                              doc.documentType === 'dpr' ? '#f59e0b' :
                              doc.documentType === 'application' ? '#10b981' :
                              '#64748b',
                            fontWeight: 500,
                            fontSize: '0.7rem'
                          }}
                        />
                      </TableCell>
                      <TableCell>{doc.fileName}</TableCell>
                      <TableCell>{formatFileSize(doc.fileSize)}</TableCell>
                      <TableCell>{doc.uploadedByName}</TableCell>
                      <TableCell>
                        {new Date(doc.createdAt).toLocaleDateString()}
                      </TableCell>
                      <TableCell align="right">
                        <Tooltip title="Download">
                          <IconButton 
                            size="small" 
                            onClick={() => downloadDocument(doc)}
                            sx={{ color: '#3b82f6' }}
                          >
                            <DownloadIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        {(isHigherAuthority(userSession) || 
                          canAccessFeature(userSession, 'manage_documents') ||
                          canAccessFeature(userSession, 'edit_documents')) && !doc.isSyntheticProof && (
                          <Tooltip title="Delete">
                            <IconButton 
                              size="small"
                              onClick={() => handleDeleteDocument(doc)}
                              sx={{ color: '#ef4444' }}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDocumentsDialog}>Close</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default History;


